import React from "react";
import Tabs from "../Tabs/Tabs";
import Panel from "../Tabs/Panel";
import "./ProfileTabs.css";
import {
  Package,
  Gear,
  AddressBook,
  Phone,
  SignOut,
} from "phosphor-react";
import MyOrders from "../MyOrders/MyOrders";
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../../appState/slices/auth/authSlice";
import { setToastMessage } from "../../appState/slices/util/utilSlice";
import { useNavigate } from "react-router-dom";
import Settings from "../Settings/Settings";
import Addresses from "../Addresses/Addresses";
import ContactUs from "../ContactUs/ContactUs";
const ProfileTabs = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(state => state.auth.user);
const logOut = async () => {
  try {
    localStorage.removeItem("accessToken");

    await dispatch(logoutUser({}));

    dispatch(
      setToastMessage({
        type: "success",
        message: "User logged out successfully",
        show: true,
      })
    );

    navigate("/");

  } catch (error) {
    console.error("Error signing out:", error);
  }
};
  return (
    <div className="profiletabdiv">
      <Tabs pagename="profilepage">
        <Panel title="my orders" icon={<Package size={20} />}>
          <MyOrders />
        </Panel>
        <Panel title="settings" icon={<Gear size={20} />}>
          <Settings />
        </Panel>
        <Panel title="addresses" icon={<AddressBook size={20} />}>
          <Addresses />
        </Panel>
        <Panel title="contact us" icon={<Phone size={20} />}>
          <ContactUs />
        </Panel>
        <Panel
          title="sign out"
          icon={<SignOut size={20} />}
          onClickFunc={logOut}
        ></Panel>
      </Tabs>
    </div>
  );
};

export default ProfileTabs;
